export default __webpack_public_path__ + "static/media/Component3581.44da75ce.svg";